var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWemix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#27EA84",
    fillRule: "evenodd",
    d: "M18.857 12a6.857 6.857 0 0 1-13.498 1.714h.89A6.002 6.002 0 0 0 17.998 12h-.683l-.922 1.177a.359.359 0 0 1-.655-.092l-.57-2.156l-.606 2.993c-.079.392-.642.38-.705-.015l-.563-3.527l-.77 5.706a.35.35 0 0 1-.526.257a.35.35 0 0 1-.172-.351l1.085-8.027c.055-.41.645-.416.71-.009l.63 3.956l.52-2.572c.075-.371.601-.387.698-.02l.739 2.791l.602-.811c.065-.109.182-.157.309-.157h1.684q.053.421.053.857m-.216-1.714a6.857 6.857 0 0 0-13.445 2.572h1.792c.13 0 .25-.085.314-.2l.433-.631l.782 2.523c.109.351.614.33.693-.03l.542-2.467l.627 3.932c.065.41.658.4.71-.01l1.038-8.087a.352.352 0 0 0-.698-.09l-.733 5.71l-.537-3.365c-.062-.391-.62-.407-.704-.02l-.652 2.972l-.636-2.05a.36.36 0 0 0-.657-.066L6.784 12H6a6 6 0 0 1 11.751-1.714z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWemix);
export default __webpack_public_path__ + "static/media/wemix.df504cd7f2302684ef511fe33f52173b.svg";
export { ForwardRef as ReactComponent };